const MAX_TIMEOUT_MS = 2 ** 31 - 1;

/**
 * setTimeout is limited to ~24.8 days (2^31-1 ms). Longer delays overflow and fire immediately.
 * This helper reschedules until the full delay elapses.
 */
export function setLongTimeout(callback, delayMs) {
	const deadline = Date.now() + Math.max(0, Number(delayMs) || 0);
	let timerId = null;
	let cancelled = false;

	const tick = () => {
		if (cancelled) {
			return;
		}

		const remaining = deadline - Date.now();
		if (remaining <= 0) {
			callback();
			return;
		}

		timerId = window.setTimeout(tick, Math.min(remaining, MAX_TIMEOUT_MS));
	};

	tick();

	return () => {
		cancelled = true;
		if (timerId !== null) {
			window.clearTimeout(timerId);
			timerId = null;
		}
	};
}
